import __DRAWER from './Drawer';
import __NAVIGATION from './Navigation';

const Components = {
    Navigation : __NAVIGATION,
    Drawer : __DRAWER
}

export default Components;